import React, { useState, useEffect } from 'react'
import {
  Panel,
  Button,
  Row,
  Col,
  ControlLabel,
  SelectPicker,
  DatePicker,
  Message,
  Uploader,
  Icon,
  Radio,
  RadioGroup,
} from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../utils/loading'
import InputForm from '../../components/forms/input/InputForm'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { useParams, useHistory } from 'react-router-dom'
import pathname from '../../constants/pathname'
import { isRequired, isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { updateChangeSubProjectStatus } from '../../redux/actions/changeProjectStatus'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import classNames from 'classnames'

export default function ChangeSubProjectStatusWidget({ schema: _schema, disabledForm, ...props }) {
  // const { showCommandButton, isEditAll, isApprove } = props
  // const [isEdit, setIsEdit] = useState(false)
  const [isError, setIsError] = useState(false)
  // const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [request, setRequest] = useState()
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(_schema)

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const mode = location.search.substring(1)
  const history = useHistory()

  const onSubmit = (data) => {
    console.log('onSubmit data', data)
    let request = {
      //status: data.projectStatus,
      workSummary: data.workSummary,
      approveSummary: data.approveSummary,
      approveType: data.approveType,
      buttonText: formSchema?.approveType ? formSchema.approveButtonText : formSchema.buttonText,
    }

    setRequest(request)
    setIsShowConfirm(true)
  }

  const handleCallService = async () => {
    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      const response = await updateChangeSubProjectStatus(projectId, request)
      console.log(response)
      if (response.success) {
        //success jump to new page
        setIsError(false)
        setIsShowConfirm(false)
        doneLoading()
        setIsLoading(false)
        sessionStorage.setItem('projectId', response.model.newProjectVersionId)
        sessionStorage.setItem('sub_projectId', response.model.newProjectVersionId)
        //sessionStorage.setItem('param', '')

        return history.push(
          //  `${pathname.subProject.overviewSubProject}/${response.model.newProjectVersionId}`
          `${pathname.subProject.overviewSubProject}`
        )
      }
    } catch (e) {
      if (e?.response?.data) {
        setIsError(e.response.data.errors?.message)
      } else {
        setIsError('เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ')
      }
    }
    setIsShowConfirm(false)
    doneLoading()
    setIsLoading(false)
  }

  const onConfirm = () => {
    handleCallService()
    //setIsShowConfirm(false)
  }

  const onCancle = () => {
    setRequest()
    setIsShowConfirm(false)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      eventKey={2}
      collapsible
      defaultExpanded
      // ref={(section) => {
      //   setSection(section)
      // }}
    >
      {formSchema?.approveType
        ? formSchema?.workSummary?.value && (
            <Message
              type="info"
              description={formSchema.workSummary.value}
              style={{ marginBottom: 20 }}
            />
          )
        : formSchema?.approveSummary?.value && (
            <Message
              type="success"
              description={formSchema.approveSummary.value} //'หัวหน้าหน่วยจัดการ : อนุมัติให้ แก้ไขรายละเอียดโครงการ'}
              style={{ marginBottom: 20 }}
            />
          )}

      {formSchema?.approveType && (
        <Row>
          <Col xs={24} sm={24} md={18} lg={18}>
            <ControlLabel
              className={classNames(isRequired(formSchema.approveType.validators) && 'required')}
            >
              {formSchema.approveType.label}
            </ControlLabel>
            <ErrorMessage error={errors.urbanType} />
            <Controller
              name={formSchema.approveType.name}
              defaultValue={formSchema.approveType.value}
              control={control}
              render={(props) => {
                return (
                  <RadioGroup
                    value={props.value}
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  >
                    {formSchema.approveType.options.map((item) => {
                      return (
                        <>
                          <Radio value={item.value}>{item.label}</Radio>
                        </>
                      )
                    })}
                  </RadioGroup>
                )
              }}
            />
          </Col>
        </Row>
      )}

      {/* {mode != '1' && mode != '0' && (
        <Row>
          <Col xs={24} sm={24} md={24} lg={24}>
            <p>{formSchema.currentStatus || ''}</p>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24}>
            <ErrorMessage error={errors[formSchema.projectStatus.name]} />
            <ControlLabel>
              {requiredFiled(formSchema.projectStatus.validators, formSchema.projectStatus.label)}
            </ControlLabel>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24}>
            <Controller
              key={formSchema.projectStatus.name}
              name={formSchema.projectStatus.name}
              control={control}
              rules={isValidators(formSchema.projectStatus.validators)}
              defaultValue={formSchema.projectStatus.value}
              render={(props) => {
                return (
                  <SelectPicker
                    data={formSchema.projectStatus.options}
                    style={{ width: '100%' }}
                    searchable={false}
                    placeholder={formSchema.projectStatus.hint}
                    value={props.value}
                    onChange={(value) => {
                      props.onChange(value)
                      clearErrors(formSchema.projectStatus.name)
                    }}
                  />
                )
              }}
            />
          </Col>
        </Row>
      )} */}

      {formSchema?.approveType
        ? formSchema?.approveSummary && (
            <Row>
              {!disabledForm ? (
                <InputForm
                  schema={formSchema.approveSummary}
                  rows={3}
                  componentClass="textarea"
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                />
              ) : (
                <>
                  <p>{formSchema.approveSummary.label}</p>
                  <p>&nbsp;&nbsp;&nbsp;&nbsp;{formSchema.approveSummary.value}</p>
                </>
              )}
            </Row>
          )
        : formSchema?.workSummary && (
            <Row>
              {!disabledForm ? (
                <InputForm
                  schema={formSchema.workSummary}
                  rows={3}
                  componentClass="textarea"
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                />
              ) : (
                <>
                  <p>{formSchema.workSummary.label}</p>
                  <p>&nbsp;&nbsp;&nbsp;&nbsp;{formSchema.workSummary.value}</p>
                </>
              )}
            </Row>
          )}

      {isError && <Message showIcon type="error" description={isError} />}

      <div className="right">
        <hr />
        {formSchema?.approveType
          ? !disabledForm && (
              <SaveButton
                children={formSchema.approveButtonText}
                onClick={handleSubmit(onSubmit)}
                disabled={isLoading}
              />
            )
          : !disabledForm && (
              <SaveButton
                icon="send"
                children={formSchema.buttonText}
                onClick={handleSubmit(onSubmit)}
                disabled={isLoading}
              />
            )}
      </div>

      <ConfirmWidget
        // title={`ยืนยันการ${formSchema.buttonText}`}
        show={isShowConfirm}
        detail={`กรุณายืนยันการ${request?.buttonText}`}
        onCancle={onCancle}
        onConfirm={onConfirm}
      />
    </Panel>
  )
}
